"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerSummary = ManagerSummary;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../constants/routes");
function ManagerSummary(props) {
    var _a = props.managers, managers = _a === void 0 ? [] : _a;
    var MAX_VISIBLE_MANAGERS = 3;
    if (!managers.length) {
        return (0, jsx_runtime_1.jsx)("span", { className: "text-sm text-medium-gray", children: "No managers assigned" });
    }
    var visibleManagers = managers.slice(0, MAX_VISIBLE_MANAGERS);
    var remainingCount = managers.length - visibleManagers.length;
    return ((0, jsx_runtime_1.jsxs)("span", { className: "text-sm text-dark-gray-1", children: [visibleManagers.map(function (manager, index) { return ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: (0, react_router_dom_1.generatePath)(routes_1.ROUTES.USER_VIEW, { id: manager.id }), className: "text-primary-navy hover:underline", children: manager.name.split(" ")[0] }), index < visibleManagers.length - 1 && ", "] }, "".concat(manager.id, "-").concat(index))); }), remainingCount > 0 && " and ".concat(remainingCount, " other").concat(remainingCount === 1 ? "" : "s")] }));
}
